module.exports = __webpack_public_path__ + "static/media/student-score-200p.ac0a8071.png";